export const SEARCH_PROFILE = `
query($email: String) {
  searchProfileByEmail(email: $email) {
    id
    firstName
    lastName
    userName
    email
    balance
  }
}
`;

export const PROFILES_CONNECTION = `
query($userName: String) {
  profilesConnection(where: { userName: $userName }) {
    aggregate {
      count
    }
  }
}
`;
